module.exports = __webpack_public_path__ + "media/packs/images/flags/TD-3c446b7cdd74377ef437950579a70586.png";